
import {
    TableResult,
    UserATableDto,
    UserAEditDto, OrganizationDto, OrganizationOrUserSelectOption, UserAdminTableFiltersJson
} from '@/global'
import ApiBase from "@/api/api-base";

export default class extends ApiBase {
    static adminAvailableOrganizations(cb: (organizations: OrganizationDto[]) => void, errorCb: (errorMessage?: string) => void) {
        return this._defaultGetResponse('/api/users-a/admin-available-organizations', null, cb, errorCb);
    }
    static adminVisibilityRuleOptions(searchTerm: string, cb: (options: OrganizationOrUserSelectOption[]) => void, errorCb: (errorMessage?: string) => void) {
        return this._defaultGetResponse('/api/users-a/admin-visibility-rule-options', {
            params: { searchTerm }
        }, cb, errorCb);
    }

    static sendUserInvite(email: string, organizationId: number, cb: (data: { success: boolean }) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultGetResponse('/api/users-a/send-user-invite', {
            params: { email, organizationId }
            }, cb, errorCb);
    }

    static generateUserInviteKey(organizationId: number, cb: (data: { key: string }) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultGetResponse('/api/users-a/generate-user-invite-key', {
            params: { organizationId }
        }, cb, errorCb);
    }

    static getUserEdit(id: number, cb: (user: UserAEditDto) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultGetResponse('/api/users-a/edit-user', {
            params: { id }
        }, cb, errorCb);
    }

    static updateUserEdit(user: UserAEditDto, successCb: (data: { success: boolean, isAnyChanges: boolean }) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultPostResponse('/api/users-a/edit-user', user, null, successCb, errorCb);
    }

    static disableEnableUser(userId: number, isDisabled: boolean, successCb: (data: { success: boolean }) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultGetResponse('/api/users-a/disable-enable-user', {
            params: { userId, isDisabled }
        }, successCb, errorCb);
    }

    static usersForTable(page: number, filters: UserAdminTableFiltersJson, cb: (usersResult: TableResult<UserATableDto>) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultGetResponse('/api/users-a/table', {
            params: {
                page,
                userAccess: filters.userAccess,
                isNeedActive: filters.isNeedActive,
                username: filters.username,
                fullName: filters.fullName,
                mapRegionId: filters.mapRegionId,
                mapDistrictId: filters.mapDistrictId,
                mapPointId: filters.mapPointId,
                organizationId: filters.organizationId,
                positionName: filters.positionName,
            }
        }, cb, errorCb);
    }

    static getUsersTableFilters(successCb: (filters: UserAdminTableFiltersJson) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultGetResponse('/api/users-a/table-filters', null, successCb, errorCb);
    }

    static usersTableFiltersSave(filters: UserAdminTableFiltersJson, successCb: (data: { success: boolean }) => void, errorCb: (errorMessage?: string) => void) {
        this._defaultPostResponse('/api/users-a/table-filters-save', filters, null, successCb, errorCb);
    }
}
